import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const awardsData = [
    {
        id: 1,
        year: "2025",
        awards: [
            "ET NOW Most Innovative Organization",
            "Aegis Graham Bell Award for Project Indus"
        ]
    },
    {
        id: 2,
        year: "2024",
        awards: [
            "Tech Leadership Excellence Summit",
            "Global AI Breakthrough Recognition"
        ]
    },
    {
        id: 3,
        year: "2023",
        awards: [
            "National Innovation Ecosystem Trophy",
            "Pioneering Research Framework Award"
        ]
    },
    {
        id: 4,
        year: "2022",
        awards: [
            "Emerging DeepTech Startup of the Year",
            "Digital Transformation Frontier Certificate"
        ]
    }
];

export default function InnovationAwardsSection() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel);
            },
            created() {
                setLoaded(true);
            },
            breakpoints: {
                "(min-width: 640px)": {
                    slides: { perView: 1.5, spacing: 20 },
                },
                "(min-width: 768px)": {
                    slides: { perView: 2, spacing: 20 },
                },
                "(min-width: 1024px)": {
                    slides: { perView: 3, spacing: 24 },
                },
            },
            slides: { perView: 1.1, spacing: 16 },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;

                function clearNextTimeout() {
                    clearTimeout(timeout);
                }

                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }

                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseleave", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full py-[40px] md:pb-[100px] overflow-hidden font-sora bg-white select-none">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <div className="text-start mb-[24px] md:mb-[60px]">
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Innovation Awards
                    </h2>
                </div>

                <div className="relative">
                    <div ref={sliderRef} className="keen-slider !overflow-visible lg:!overflow-hidden py-4">
                        {awardsData.map((item) => (
                            <div key={item.id} className="keen-slider__slide">
                                <div className="w-full h-[240px] sm:h-[260px] md:h-[280px] p-6 sm:p-8 flex flex-col justify-between border border-[#01386A15] bg-white transition-all duration-[400ms] ease-in-out relative group cursor-pointer md:hover:bg-[#01386A] md:hover:border-[#01386A] md:hover:shadow-xl rounded-sm">

                                    <div>
                                        <h3 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] md:group-hover:text-white transition-colors duration-[400ms]">
                                            {item.year}
                                        </h3>
                                    </div>

                                    <div className="space-y-2">
                                        {item.awards.map((award, i) => (
                                            <p
                                                key={i}
                                                className="text-[#49577A] md:group-hover:text-white/90 text-[14px] lg:text-[16px] font-graphik font-[500] leading-relaxed transition-colors duration-[400ms]"
                                            >
                                                {award}
                                            </p>
                                        ))}
                                    </div>

                                    <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] md:group-hover:bg-[#ED6800] transition-colors duration-[400ms]"></div>
                                    <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-[400ms] ease-out group-hover:w-full z-10"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {loaded && instanceRef.current && (
                    <div className="flex items-center gap-4 mt-6 md:mt-8">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                instanceRef.current?.prev();
                            }}
                            className="w-10 h-10 rounded-full border border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white flex items-center justify-center transition-colors duration-300"
                            aria-label="Previous slide"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                            </svg>
                        </button>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                instanceRef.current?.next();
                            }}
                            className="w-10 h-10 rounded-full border border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white flex items-center justify-center transition-colors duration-300"
                            aria-label="Next slide"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                )}

            </div>
        </section>
    );
}